import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import VehicleTypeServices from "services/VehicleTypeServices";
import { notifyError, notifySuccess } from "utils/toast";

const useVehicleTypeSubmit = (id, data) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate, lang } =
    useContext(SidebarContext);
  const [, setResData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm();


  const onSubmit = async ({ name, description }) => {
    setLoading(true);
    try {
      setIsSubmitting(true);
      const categoryData = {
        name: name
      };

      if (id) {
        const res = await VehicleTypeServices.updateVehicleType(id, categoryData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
        reset();
      } else {
        const res = await VehicleTypeServices.addVehicleType(categoryData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      setIsSubmitting(false);
      notifyError(err ? err?.response?.data?.message : err?.message);
      //closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };


  useEffect(() => {
    if (!isDrawerOpen) {
      setResData({});
      setValue("name");
      clearErrors("name");

      return;
    }
    if (id) {
      (async () => {
        try {
          const res = await VehicleTypeServices.getVehicleTypeById(id);

          if (res) {
            setResData(res.data);
            setValue("name", res.data.name);
          }
        } catch (err) {
          notifyError(err ? err.response.data.message : err.message);
        }
      })();
    }
  }, [id, setValue, isDrawerOpen, clearErrors, data, lang]);

  return {
    register,
    handleSubmit,
    onSubmit,
    errors,
    isSubmitting,
    loading, setLoading,
  };
};

export default useVehicleTypeSubmit;
